// extracted by mini-css-extract-plugin
module.exports = {"page-spinner":"spinner__page-spinner___ovAeS","pageSpinner":"spinner__page-spinner___ovAeS","spin":"spinner__spin___9VJ-h","small":"spinner__small___bhW8p"};